import styled from 'styled-components';

export const InputAndErrorWrapper = styled.div`
  flex-direction: column;
`;

export const ErrorMsg = styled.p`
  color: red;
  font-size: 0.7rem;
`;
